import { render, staticRenderFns } from "./EditDesign.vue?vue&type=template&id=34db5a96&scoped=true&"
import script from "./EditDesign.vue?vue&type=script&lang=js&"
export * from "./EditDesign.vue?vue&type=script&lang=js&"
import style0 from "./EditDesign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditDesign.vue?vue&type=style&index=1&id=34db5a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34db5a96",
  null
  
)

export default component.exports